import PropTypes from 'prop-types'
import { memo } from 'react'
import { useIntl } from 'react-intl'
import { ROLES } from '../../../../containers/TeamsManagement/constants'
import { badgeColorOptions } from '../../../stories/atoms/badges/constants'
import ListItemComponent from '../../../stories/molecules/list-items'
import { iconSizeOptions } from '../../../stories/atoms/icons/icons-sizes'
import StatusIndicationComponent from '../../../stories/atoms/status-indication'
import { statusIndicationMemberVariantOptions } from '../../../stories/atoms/status-indication/constants'
import { isEmpty } from 'lodash'

const handleRoleColor = (role) => {
  switch (role) {
    case ROLES.POWERUSER:
      return badgeColorOptions.VIOLET
    case ROLES.ASSISTANT:
      return badgeColorOptions.BLUE
    case ROLES.EXTERNALVISITOR:
      return badgeColorOptions.TURQUOISE
    case ROLES.SUBCONTRACTOR:
      return badgeColorOptions.OCHRE
    case ROLES.VIEWER:
      return badgeColorOptions.GREEN
    default:
      return badgeColorOptions.OCHRE
  }
}

const TeamItem = ({ item, isSelected = false, onToggleSelect = () => {} }) => {
  const { formatMessage } = useIntl()

  if (isEmpty(item)) return null

  return (
    <ListItemComponent.Item
      itemKey={item.id}
      isCheck={isSelected}
      leadingIcon={
        <StatusIndicationComponent
          size={iconSizeOptions['ICON-L']}
          variant={statusIndicationMemberVariantOptions.TEAM}
        />
      }
      title={`${item.name}`}
      secondaryText={item.members.length}
      badge={{
        label:
          formatMessage({ id: `personas_roleLabel${item.role}` }) || item.role,
        color: handleRoleColor(item.role)
      }}
      style={{ borderRadius: 0, border: 0 }}
      onCheck={() => onToggleSelect(item.id)}
      noPadding
    />
  )
}

TeamItem.propTypes = {
  item: PropTypes.object,
  isSelected: PropTypes.bool,
  onToggleSelect: PropTypes.func
}

const MemoizedTeamItem = memo(TeamItem)
MemoizedTeamItem.displayName = 'TeamItem'

export default MemoizedTeamItem
